import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, computed, toValue } from 'vue'
import KCircleIcon from './KCircleIcon.vue'

interface IProps {
  icons?: string[]
  modelValue?: string
  expanded?: boolean
}

interface IEmits {
  (event: 'update:model-value', data: string): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'KIconPicker',
  props: {
    icons: { default: () => [] },
    modelValue: { default: '' },
    expanded: { type: Boolean, default: false }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const expandedRef = ref(props.expanded)
const selectedIconRef = ref<string | null>(toValue(() => props.modelValue))

const isChecked = computed(() => {
  const iconIndex = props.icons.findIndex((item) => item === props.modelValue)
  return props.icons[iconIndex]
})

const handleSelectIcon = (name: string) => {
  if (selectedIconRef.value === name) {
    selectedIconRef.value = null
    emit('update:model-value', '')
  } else {
    selectedIconRef.value = name
    emit('update:model-value', name)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: "k-icon-picker row column justify-center items-center q-pa-lg",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["k-icon-picker__icons-box hide-scrollbar q-mb-12 full-width", expandedRef.value ? 'k-icon-picker__icons-box--expanded' : 'k-icon-picker__icons-box--collapsed'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.icons, (icon, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "cursor-pointer"
          }, [
            _createVNode(KCircleIcon, {
              name: icon,
              borderless: "",
              size: "32px",
              background: "off-white-10",
              "is-selected": isChecked.value === icon,
              "is-hover": "",
              "root-class": "q-pa-sm",
              onClick: ($event: any) => (handleSelectIcon(icon))
            }, null, 8, ["name", "is-selected", "onClick"])
          ]))
        }), 128))
      ], 2),
      _createElementVNode("span", {
        class: "cursor-pointer q-mt-md fw-500 fs-12px text-space-b-100",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (expandedRef.value = !expandedRef.value))
      }, _toDisplayString(expandedRef.value ? 'Show Less' : 'Show More'), 1)
    ]),
    _: 1
  }))
}
}

})